import { Link } from 'react-router-dom';
import { useApiGet } from '../../lib/useApiGet.js';
import { tenantBasePath } from '../../lib/tenant.js';
import type { MasterDataRecord } from '../../lib/types/masterData.js';

/**
 * Resolves a finance `partyId` to a presentation-safe label. Never renders
 * the UUID. Destination denial is handled on the destination route.
 */
export function PartyLabel({
  slug,
  partyId,
  href,
}: {
  readonly slug: string;
  readonly partyId: string;
  readonly href?: string;
}) {
  const base = tenantBasePath(slug);
  const party = useApiGet<MasterDataRecord>(
    partyId ? `${base}/api/v1/master-data/parties/${partyId}` : null,
    [slug, partyId],
  );

  if (party.status === 'loading') {
    return <span style={{ color: 'var(--sk-fg-muted)' }}>…</span>;
  }
  if (party.status === 'error') {
    return (
      <span style={{ color: 'var(--sk-fg-muted)', fontSize: 13 }}>
        {party.error.status === 403
          ? 'دسترسی به طرف‌حساب ندارید'
          : party.error.status === 404
            ? 'طرف‌حساب پیدا نشد'
            : 'طرف‌حساب قابل نمایش نیست'}
      </span>
    );
  }

  const name = typeof party.data.name === 'string' ? party.data.name : null;
  const code = typeof party.data.code === 'string' ? party.data.code : null;
  const label = name ?? code;
  if (!label) {
    return <span style={{ color: 'var(--sk-fg-muted)' }}>طرف‌حساب</span>;
  }

  if (href) {
    return (
      <Link to={href} style={{ fontWeight: 500 }}>
        {label}
      </Link>
    );
  }
  return <span style={{ fontWeight: 500 }}>{label}</span>;
}
